<template>
    <div class="intro" v-show="introActive">
        <transition name="intro-text-transition">
            <div class="intro-text" v-show="animateIntro">
                <p>
                    <slot></slot>
                </p>
            </div>
        </transition>

        <transition name="intro-backdrop-transition">
            <div class="backdrop" v-show="animateIntro">
            </div>
        </transition>
    </div>
</template>

<script src="./product-intro.js"></script>
